module.exports = __webpack_public_path__ + "static/media/report_bg.7ef21cf0.svg";